import { createApp, h, Fragment } from 'vue'
import App from './App.vue'
import router from './router'
import 'mdb-vue-ui-kit/css/mdb.min.css';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import axios from "axios";
import { useUserInfoStore } from "@/stores/userInfo";
import LoadScript from "vue-plugin-load-script";

import {
    MDBIcon,
    MDBInput,
    MDBContainer,
    MDBCard,
    MDBCardTitle,
    MDBCardText,
    MDBCheckbox,
    MDBBtn,
    MDBSelect,
    MDBFile,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBRadio,
    MDBAccordion,
    MDBAccordionItem,
    MDBTransition,
    MDBSpinner
} from 'mdb-vue-ui-kit';

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

async function bootstrap() {
    let app;

    if (process.env.NODE_ENV === 'development') {
        const VueAxe = await import('vue-axe');
        app = createApp({
            render: () => h(Fragment, [h(App), h(VueAxe.VueAxePopup)]),
        });
        app.use(VueAxe.default, {
            runOptions: {
                runOnly: {
                    type: 'tag',
                    values: ['wcag2a', 'wcag2aa', 'wcag21a', 'wcag21aa'],
                },
            },
        });
    } else {
        app = createApp(App);
    }

    // global components
    app.component('MDBInput', MDBInput)
    app.component('MDBContainer', MDBContainer)
    app.component('MDBCard', MDBCard)
    app.component('MDBCardTitle', MDBCardTitle)
    app.component('MDBCardText', MDBCardText)
    app.component('MDBCheckbox', MDBCheckbox)
    app.component('MDBIcon', MDBIcon)
    app.component('MDBBtn', MDBBtn)
    app.component('MDBSelect', MDBSelect)
    app.component('MDBFile', MDBFile)
    app.component('MDBModal', MDBModal)
    app.component('MDBModalHeader', MDBModalHeader)
    app.component('MDBModalTitle', MDBModalTitle)
    app.component('MDBModalBody', MDBModalBody)
    app.component('MDBModalFooter', MDBModalFooter)
    app.component('MDBRadio', MDBRadio)
    app.component('MDBAccordion', MDBAccordion)
    app.component('MDBAccordionItem', MDBAccordionItem)
    app.component('MDBTransition', MDBTransition)
    app.component('MDBSpinner', MDBSpinner)

    app.use(LoadScript)

    axios.interceptors.request.use((config) => {
        const userInfoStore = useUserInfoStore()
        if (userInfoStore.token) {
            config.headers["access-token"] = userInfoStore.token.token
            config.headers["token-type"] = "Bearer"
            config.headers["client"] = userInfoStore.token.client
            config.headers["uid"] = userInfoStore.email
        }
        return config
    })

    app.use(router)
    app.use(pinia)

    app.config.globalProperties.handleHttpError = function(error) {
        if (error === null) throw new Error('Unrecoverable error!! Error is null!')
        if (axios.isAxiosError(error)) {
            const response = error?.response
            const request = error?.request

            if (error.code === 'ERR_NETWORK') {
                alert("There was a connection issue. Please make sure you are connected to the internet. If you are, please try again later.")
            } else if (error.code === 'ERR_CANCELED') {
                alert("Connection canceled. Please try again.")
            }
            if (response) {
                const statusCode = response?.status
                if (statusCode === 404) {
                    alert("The requested resource does not exist or has been deleted.")
                } else if (statusCode === 401) {
                    const userInfoStore = useUserInfoStore()  // called here so pinia is ready
                    userInfoStore.$reset()
                    router.push(process.env.VUE_APP_BASE_PATH + "/login")
                }
            } else if (request) {
                alert("The following error occurred:" + error)
            }
        }
        console.log(error.message)
    }

    app.mount('#app')
}

bootstrap();